var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.086 9.56017C0.710901 9.93516 0.500113 10.4438 0.5 10.9742L0.5 12.0007H1.5265C2.05689 12.0006 2.56551 11.7898 2.9405 11.4147L9.612 4.74317L7.7575 2.88867L1.086 9.56017Z",
    fill: "#EE4E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0725 0.427435C11.9507 0.305553 11.8062 0.208863 11.647 0.142893C11.4879 0.0769241 11.3173 0.0429688 11.145 0.0429688C10.9727 0.0429687 10.8021 0.0769241 10.643 0.142893C10.4838 0.208863 10.3393 0.305553 10.2175 0.427435L8.4645 2.18094L10.319 4.03544L12.0725 2.28244C12.1944 2.16068 12.2911 2.0161 12.357 1.85695C12.423 1.6978 12.457 1.52721 12.457 1.35494C12.457 1.18266 12.423 1.01207 12.357 0.852922C12.2911 0.693775 12.1944 0.549191 12.0725 0.427435Z",
    fill: "#EE4E56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil1);
export default __webpack_public_path__ + "static/media/pencil1.accee879c794ad0d852e15e68f065979.svg";
export { ForwardRef as ReactComponent };